import { render, staticRenderFns } from "./houseDetail.vue?vue&type=template&id=510018ab&scoped=true&"
import script from "./houseDetail.vue?vue&type=script&lang=js&"
export * from "./houseDetail.vue?vue&type=script&lang=js&"
import style0 from "./houseDetail.vue?vue&type=style&index=0&id=510018ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510018ab",
  null
  
)

export default component.exports